if (!customElements.get('ccc-complete-set')) {
  customElements.define('ccc-complete-set', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      if (this.dataset.placement === 'product' && typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          const map = Object.fromEntries(this.dataset.seedVariants.split(',').map(s => s.split(':')));
          if (!(String(data.variant?.id) in map)) return;
          const format = map[String(data.variant.id)] === 'true' ? 'physical' : 'digital';
          this.querySelectorAll('[data-set-format]').forEach(panel => panel.hidden = panel.dataset.setFormat !== format);
        });
      }
      this.addEventListener('submit', async event => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        event.preventDefault();
        if (this.pending) return;
        this.pending = true;
        const buttons = [...this.querySelectorAll('button')];
        buttons.forEach(button => button.disabled = true);
        const status = this.querySelector('[role="status"]');
        status.textContent = 'Adding to your cart…';
        let added = false;
        try {
          const notification = document.querySelector('cart-notification');
          const body = new FormData(form);
          if (notification) {
            body.append('sections', notification.getSectionsToRender().map(section => section.id).join(','));
            body.append('sections_url', window.location.pathname);
            notification.setActiveElement(form.querySelector('button'));
          }
          const response = await fetch(form.action + '.js', {method:'POST',body,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Please try again.');
          added = true;
          if (this.dataset.placement === 'cart') { window.location.reload(); return; }
          status.textContent = 'Added to your cart.';
          form.querySelector('button').textContent = 'Added';
          form.dataset.added = 'true';
          if (notification) {
            try { notification.renderContents(result); }
            catch { window.location.assign(window.routes?.cart_url || '/cart'); return; }
          } else { window.location.assign(window.routes?.cart_url || '/cart'); return; }
        } catch (error) { status.textContent = added ? 'Added to your cart. View your cart to continue.' : error.message; }
        finally {
          this.pending = false;
          buttons.forEach(button => button.disabled = button.form?.dataset.added === 'true');
        }
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
